import { generatePath } from "react-router-dom";

import {
	INVOICE_DETAILS_PATH,
	INVOICES_PENDING_PATH,
	PROJECT_DETAILS_PATH_WITH_DEFAULT_TAB_ID,
	QUOTAS_INDEX_PATH,
} from "~/constants/appRoutes.ts";
import { formatDateCompact, formatSmartDateRange, parseDateString } from "~/utils/dateAndTimeUtils.ts";

export const validQuotaDetailsNavigatedFromOrigins = {
	QUOTAS_INDEX: "index",
	PROJECT: "project",
	INVOICE: "invoice",
	PENDING_INVOICES: "pending-invoices",
} as const;

export type ValidQuotaDetailsNavigatedFromOrigin = typeof validQuotaDetailsNavigatedFromOrigins[keyof typeof validQuotaDetailsNavigatedFromOrigins];

type BackPathIds = {
	invoiceId?: string;
	projectId?: string;
};

export function getQuotaDetailsBackPath(from: ValidQuotaDetailsNavigatedFromOrigin | undefined,
	{ invoiceId, projectId }: BackPathIds): string {
	if (from === validQuotaDetailsNavigatedFromOrigins.PROJECT && projectId) {
		return generatePath(PROJECT_DETAILS_PATH_WITH_DEFAULT_TAB_ID, { projectId });
	}

	if (from === validQuotaDetailsNavigatedFromOrigins.INVOICE && invoiceId) {
		return generatePath(INVOICE_DETAILS_PATH, { invoiceId });
	}

	if (from === validQuotaDetailsNavigatedFromOrigins.PENDING_INVOICES) {
		return INVOICES_PENDING_PATH;
	}

	return QUOTAS_INDEX_PATH;
}

// The "Gültigkeit" value of the details card. The API sends both dates as "YYYY-MM-DD".
export function formatQuotaUsablePeriod(usableFrom: string | null, usableUntil: string | null): string {
	if (usableFrom && usableUntil) {
		return formatSmartDateRange(parseDateString(usableFrom), parseDateString(usableUntil));
	}

	if (usableFrom) {
		return `Ab ${formatDateCompact(parseDateString(usableFrom))}`;
	}

	if (usableUntil) {
		return `Bis ${formatDateCompact(parseDateString(usableUntil))}`;
	}

	return "Ohne Einschränkung";
}
